import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";

import {
  taxLiabilityReport,
  payrollSummaryReport,
} from "../../store/slices/reportSlice";

import { formatDateForApi } from "../../utils/dateUtils";

const ReportModal = ({ show, onClose, reportType, companyId }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [selectedQuickDate, setSelectedQuickDate] = useState("");

  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
  });

  const handleChange = (e) => {
    setSelectedQuickDate("");

    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const setQuickDate = (type) => {
    const today = new Date();

    let fromDate;
    let toDate;

    switch (type) {
      // Current Month
      case "month":
        fromDate = new Date(today.getFullYear(), today.getMonth(), 1);

        toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;

      // Current Year
      case "year":
        fromDate = new Date(today.getFullYear(), 0, 1);

        toDate = new Date(today.getFullYear(), 11, 31);
        break;

      default:
        return;
    }

    setSelectedQuickDate(type);

    setFormData({
      fromDate: formatDateForApi(fromDate),
      toDate: formatDateForApi(toDate),
    });
  };

  const handleGenerate = async () => {
    if (!formData.fromDate || !formData.toDate) {
      alert("Please select date range");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        companyId,
        fromDate: formData.fromDate,
        toDate: formData.toDate,
      };

      // Tax Liability Report
      if (reportType === "tax") {
        await dispatch(taxLiabilityReport(payload)).unwrap();
      }

      // Payroll Summary Report
      if (reportType === "summary") {
        await dispatch(payrollSummaryReport(payload)).unwrap();
      }

      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      {/* Header */}
      <Modal.Header closeButton>
        <Modal.Title>
          {reportType === "tax"
            ? "Generate Tax Liability Report"
            : "Generate Payroll Summary Report"}
        </Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body>
        {/* Date Inputs */}
        <div className="row">
          {/* From Date */}
          <div className="col-md-6 mb-3">
            <Form.Label>From Date</Form.Label>

            <Form.Control
              type="date"
              name="fromDate"
              value={formData.fromDate}
              onChange={handleChange}
            />
          </div>

          {/* To Date */}
          <div className="col-md-6 mb-3">
            <Form.Label>To Date</Form.Label>

            <Form.Control
              type="date"
              name="toDate"
              value={formData.toDate}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Quick Buttons */}
        <div className="d-flex flex-wrap gap-2 mt-2">
          {/* This Month */}
          <Button
            className={
              selectedQuickDate === "month"
                ? "btn_primary"
                : "btn_outline_primary_light"
            }
            onClick={() => setQuickDate("month")}
          >
            This Month
          </Button>

          {/* This Year */}
          <Button
            className={
              selectedQuickDate === "year"
                ? "btn_primary"
                : "btn_outline_primary_light"
            }
            onClick={() => setQuickDate("year")}
          >
            This Year
          </Button>
        </div>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer>
        {/* Cancel */}
        <Button className="btn_cancel" onClick={onClose}>
          Cancel
        </Button>

        {/* Generate */}
        <Button
          className="btn_primary"
          onClick={handleGenerate}
          disabled={loading}
        >
          {loading ? "Generating..." : "Generate Report"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportModal;
